/**
 * @deprecated Ce fichier est déprécié
 * 
 * ⚠️ IMPORTANT : Utilisez @/services/api.service.js à la place
 * 
 * Ce client Axios est obsolète et ne bénéficie pas :
 * - Du refresh token automatique
 * - De la gestion centralisée des erreurs
 * - De la file d'attente pour requêtes simultanées
 * 
 * Migration effectuée le : 2026-06-01
 * Raison : Harmonisation des intercepteurs Axios
 */

import apiService from '@/services/api.service';

/**
 * @deprecated Utilisez apiService.client à la place
 * Conservé temporairement pour compatibilité avec le code existant
 */
const apiClient = apiService.client;

export default apiClient;